import CryptoJS from 'crypto-js'

// 固定的密钥
const SECRET_KEY = 'hqt_b2b_aes_key_2024secret!@#$'

/**
 * AES 加密
 * @param data 要加密的数据
 * @returns 加密后的字符串
 */
export function encrypt(data: string): string {
  try {
    if (!data && data !== 0) return ''
    const strData = String(data)
    const encrypted = CryptoJS.AES.encrypt(strData, SECRET_KEY)
    return encrypted.toString()
  } catch (error) {
    console.error('Encryption failed:', error)
    return ''
  }
}

/**
 * AES 解密
 * @param encryptedData 加密的字符串
 * @returns 解密后的原始数据
 */
export function decrypt(encryptedData: string): string | null {
  try {
    if (!encryptedData) return null
    const decrypted = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY)
    return decrypted.toString(CryptoJS.enc.Utf8)
  } catch (error) {
    console.error('Decryption failed:', error)
    return null
  }
}

/**
 * 将加密字符串转换为URL安全的格式
 * @param encryptedStr 加密字符串
 * @returns URL安全的字符串
 */
export function encryptToUrl(encryptedStr: string): string {
  return encodeURIComponent(encryptedStr)
}

/**
 * 从URL参数解密
 * @param urlStr URL编码的加密字符串
 * @returns 解密后的原始数据
 */
export function decryptFromUrl(urlStr: string): string | null {
  try {
    if (!urlStr) return null
    const decoded = decodeURIComponent(urlStr)
    return decrypt(decoded)
  } catch (error) {
    console.error('URL decryption failed:', error)
    return null
  }
}

/**
 * 生成客服免登访问URL
 * @param userId 用户ID
 * @param baseUrl 基础URL（知识库页面URL）
 * @returns 加密后的访问URL
 */
export function generateCustomerServiceUrl(userId: string, baseUrl?: string): string {
  if (!userId) return ''
  const encryptedUid = encrypt(userId)
  if (!encryptedUid) return ''
  const url = baseUrl || window.location.origin + '/knowledge-base'
  return `${url}?cs_uid=${encryptToUrl(encryptedUid)}`
}

/**
 * 从URL中解析客服免登用户ID
 * @param queryString URL查询字符串或URLSearchParams
 * @returns 用户ID或null
 */
export function parseCustomerServiceUid(queryString?: string): string | null {
  try {
    const params = queryString ? new URLSearchParams(queryString) : new URLSearchParams(window.location.search)
    const encryptedUid = params.get('cs_uid')
    if (!encryptedUid) return null
    return decryptFromUrl(encryptedUid)
  } catch (error) {
    console.error('Parse customer service UID failed:', error)
    return null
  }
}
